import { all, call, put, takeEvery } from "@redux-saga/core/effects";
import { RegionService } from "../../services/region";
import { showErrorResponse } from "../../varibles/global";
import { IRegion } from "../../varibles/interface";
import { regionActions } from "./reducer";

function* getRegionsWatcher(): Generator<any, any, IRegion[]> {
    try {
        const regions = yield call(RegionService.gets)
        yield put(regionActions.getRegionsSuccess(regions));
    } catch (error) {
        yield put(regionActions.getRegionsFailure())
        showErrorResponse('Get regions failure', error);
    }
}

export default function* regionSaga() {
    yield all([
        takeEvery(regionActions.getRegions.type, getRegionsWatcher),
    ])
}
